module.exports = __webpack_public_path__ + "static/media/3O.79ad1122.png";